<template lang="html">
  <section class="app-create-project-type">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <form @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="projectType" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectType.$error ? 'is-invalid': ''" type="text"
                 @blur="$v.dataForm.projectType.$touch()" v-model="dataForm.projectType"
                 class="form-control" id="projectType">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectType.required">
              You must absolutely enter a project type !
            </div>
            <div v-if="!$v.dataForm.projectType.minLength">
              Project type must not have less than {{$v.dataForm.projectType.$params.minLength.min}} characters !
            </div>
            <div v-if="!$v.dataForm.projectType.maxLength">
              Project type must not contain more than {{$v.dataForm.projectType.$params.maxLength.max}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {uuid} from 'vue-uuid'
import {mapGetters, mapActions} from "vuex";
import {FORM_PROJECTS_TYPES_VALIDATIONS} from '../../validations/formProjectsTypes'
export default {
  name: 'CreateProjectsType',
  props: [],
  mounted () {},
  created () {},
  validations: FORM_PROJECTS_TYPES_VALIDATIONS,
  data () {
    return {
      dataForm : {
        projectTypeId: uuid.v4(),
        projectType: undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'createData'
    ]),
    onSubmit () {
      const formData = {
        project_type_id: this.dataForm.projectTypeId,
        type: this.dataForm.projectType
      };
      this.dataForm.projectTypeId = uuid.v4();
      this.createData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => {
            this.messageSubmission = '';
            this.resetForm();
          }, 5000);
        })
        .catch(data => console.log(data))
    },
    resetForm () {
      this.dataForm.projectTypeId = uuid.v4();
      this.dataForm.projectType = undefined;
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
  .app-create-project-type {}
</style>



// WEBPACK FOOTER //
// src/components/projects_types/CreateProjectsType.vue